<template>
<div class="urgency-list">
  <table class="tbl tbl--tablet-cards">
    <thead>
      <tr>
        <th width="90%">Тип</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <item
        v-for="item in list"
        :data="item"
        :remove-callback="removeItem"
        :key="item.id"
      />
    </tbody>
  </table>

  <div class="urgency-list__button-wrapper">
    <button
      type="button"
      class="button button--plus"
      @click="addItem"
      v-if="isAddBtnShow"
    >Добавить</button>
  </div>
</div>
</template>

<script>
export default {
  components: {
    item: require("./item.vue").default
  },

  data: function() {
    return {
      list: this.urgencyData,
      isAddBtnShow: true
    };
  },

  props: {
    urgencyData: {
      type: Array,
      required: true
    }
  },

  methods: {
    removeItem: function(item) {
      let index = this.list.indexOf(item);
      this.list.splice(index, 1);
    },

    addItem: function() {
      const cleanItem = {
        id: null,
        name: ""
      };
      this.list.push(cleanItem);
    },

    toggleAddBtn: function(item) {
      this.isAddBtnShow = true;
      if (item && item.length > 0) {
        if (_.last(item).id) this.isAddBtnShow = true;
        else this.isAddBtnShow = false;
      }
    }
  },

  watch: {
    list: {
      handler: function(item) {
        this.toggleAddBtn(item);
      },
      deep: true
    }
  }
};
</script>
